<template>
    <div id="" :class="tall ? 'tall': ''" class="ebook content-box">
        <div class="content">
            <div class="book">
                <img src="../assets/img/ebook.png" />
            </div>
            <div class="copy">
                <img src="../assets/img/lasso_x_small_white_logo.png" />
                <h4>Boost dit B2B salg</h4>
                <p>Den ultimative guide til at udnytte data og sælge mere B2B i 2023. Hent E-bogen og få 5 gode råde som giver flere leads og styrker salget.</p>
                <!-- <p>med Rasmus Sørensen,<br>Markedschef og ekspert i B2B-salg</p> -->
                <a href="https://lassox.com/e-bog?utm_campaign=E-bog%20follow-up&utm_source=lasso.dk&utm_medium=lasso.dk%20banner" target="_blank">
                    <img class="ebook-button" src="../assets/img/ebook-button.png" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tall: Boolean
    },
    computed: {
        
    }
}
</script>

<style lang="less">
    .ebook {
        padding: 30px 30px 15px 30px;
        background-color: #3c2b4e !important;
            
        .content {
            color: #fff;

            .book {
                margin-bottom: -15px;
                img {
                    max-width: 200px;
                    display: block;
                    margin: 0 auto;
                }
            }

            h5 {
                font-size: 20px;
                font-weight: 500;
                line-height: 30px;
                color: #FF7FB5;
                margin: 0;
            }

            h4 {
                font-size: 25px;
                font-weight: 500;
                line-height: 35px;
            }

            p {
                font-size: 15px;
                font-weight: normal;
                line-height: 25px;
                margin: 10px 0 15px 0;
            }

            .ebook-button {
                margin-top: 10px;
                height: 50px;
            }
        }

        @media only screen and (min-width: 568px) {
            &:not(.tall) {
                .content {
                    display: flex;
                    justify-content: center;
                    .book {
                        display: flex;
                        align-items: center;
                        padding-right: 30px;
                        margin-bottom: 0;
                    }

                    .copy {
                        max-width: 375px;
                    }

                }
            }
        }
    }
</style>